import { FirestoreCollections } from '@griply/types';
import {
  getDocs,
  orderBy,
  QueryFieldFilterConstraint,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { lifeAreaConverter } from './converters/life-area';
import { getAuthentication, getCollection, query, where } from './helpers';

export type Options = {
  ids?: ID[];
};

export const getLifeAreas = async (options: Options = {}) => {
  const auth = await getAuthentication();

  const conditions = [
    where('roles.all', 'array-contains', auth.currentUser?.uid),

    !!options.ids?.length && where('id', 'in', options.ids),
  ].filter(Boolean) as QueryFieldFilterConstraint[];

  return query(
    getCollection(FirestoreCollections.LifeAreas).withConverter(
      lifeAreaConverter,
    ),
    ...conditions,
    orderBy('createdAt', 'asc'),
  );
};

export const getLifeAreasDocs = async (options?: Options) => {
  const lifeAreaQuery = await getLifeAreas(options);
  const lifeAreaDocs = await getDocs(lifeAreaQuery);

  return lifeAreaDocs.docs.map((doc) => doc.data());
};
